<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre1"><a class="calibre3" id="page1"></a></p>
<div class="calibre5" id="calibre_pb_0"></div><h1 class="pt" id="heading_id_2">Part One | Theories of Community</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?3ab18042